import styled from "styled-components";
export const CountryContainer = styled.div`

width:100% ;
/* height: 100vh; */
  max-width: 1200px;
  margin: 3rem auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  z-index:10 ;


  gap: 2rem;
align-items:center ;
justify-content:center ;


`